const data = [
  { id: 1, name: "Habilitação de crédito retardatária" },
  { id: 2, name: "Impugnação de crédito retardatária" },
  { id: 3, name: "Impugnação de crédito tempestiva" },
  { id: 4, name: "Classificação de crédito público" },
  { id: 5, name: "Restituição" },
  { id: 6, name: "Pretensão" },
];

export default [...data];
